import React, { useEffect, useState, useCallback, useMemo } from "react";
import Header from "./header";
import Footer from "./footer";

import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { ignoreLayout } from "../../app/constant";
import { useAuth } from "../../app/useAuth";
import MenuComponent from "../Menu";

const Layout = (props) => {
    const auth = useAuth();
    const navigator = useNavigate();
    const location = useLocation();
    const [authData, setAuthData] = useState("");

    const ignoreRouter = [
        "/",
        "/n1",
        "/n2",
        "/n3",
        "/n4",
        "/n5",
        "/n6",
        "/n7",
        "/login",
        "/forgot",
        "/reset",
        "/register",
        "/privacy",
        "/terms",
        "/email/verify/already-success",
    ];

    // const hideHeader = ["/login", "/forgot", "/reset", "/register", "/privacy", "/terms", "/email/verify/already-success"];

    const checkRouter = useCallback((authData) => {
        if (authData === null) {
            if (!ignoreRouter.includes(location.pathname)) {
                navigator("/login");
            }
        }
    }, []);

    useEffect(() => {
        setAuthData(auth);
        checkRouter(auth);
    }, [auth, checkRouter]);

    return (
        <div className="content" style={{ minHeight: "100vh", position: "relative" }}>
            <Header auth={authData} />

            {/* <div className="container-text-to-image position-relative">
                <img
                    src={`${process.env.PUBLIC_URL}/assets/bg/DJI_0027.jpg`}
                    alt="DJI_0027"
                    style={{ width: "100%", height: 350, objectFit: "cover", objectPosition: "center" }}
                />

                <div className="position-absolute w-100 bottom-0 left-0">
                    <div className="container d-flex justify-content-center align-items-center">
                        <MenuComponent />
                    </div>
                </div>
            </div> */}

            <div className="d-flex flex-column" style={{ minHeight: "calc(100vh - 118.2px)" }}>
                <Outlet />
            </div>

            <Footer />
        </div>
    );
};

export default Layout;
